import React from "react";
import './footer.scss';
import data from "../../../pages/home-page/data";
import PrLogoFooterComponent from "../../primitives/pr-logo-footer";

export default class FooterComponent extends React.Component {

    social = [
        { title: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543276/hp2021/social/facebook.svg', link: 'https://www.facebook.com/PowToon' },
        { title: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543276/hp2021/social/linkedin.svg', link: 'https://www.linkedin.com/company/powtoon-ltd/' },
        { title: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543276/hp2021/social/youtube.svg', link: 'https://www.youtube.com/user/PowToon' },
        { title: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543276/hp2021/social/twitter.svg', link: 'https://twitter.com/PowToon' },
        { title: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543276/hp2021/social/instagram.svg', link: 'https://www.instagram.com/powtoon/' }
    ]

    constructor() {
        super();
        this.state = {
            footer: data.footer,
            activeEl: 0,
        }
        this.component = React.createRef();
    }

    componentDidMount(){
        const item = this.component.current.querySelectorAll('.column ul');
        [...item].map(element => {
            element.parentElement.style.setProperty('--list-height', `${element.getBoundingClientRect().height}px`);
        });
    }

    render() {
        return (
            <footer className="footer" ref={this.component}>
               <div className="container">
                   <div className="footer-nav">
                    {this.state.footer.map((value, index) =>
                            <div className="column" key={index}>
                                <p className="extra-title--h6" onClick={(ev) => ev.target.nextSibling.classList.contains('active') ?  ev.target.nextSibling.classList.remove('active') :  ev.target.nextSibling.classList.add('active')}>{value.name}</p>
                                <nav className="footer-list-wrap">
                                    <ul className="footer-list">
                                        {value.content.map((v, i) =>
                                            <li key={i}>
                                                <a href={v.link} className="extra-title--h7">{v.title}</a>
                                            </li>
                                        )}
                                    </ul>
                                </nav>
                            </div>
                        )}
                   </div>
                    <div className="social">
                        <PrLogoFooterComponent></PrLogoFooterComponent>
                        <ul>
                            {this.social.map((value, index)=>
                                <li key={index}>
                                    <a href={value.link}>
                                        <img src={value.title} alt="#" />
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
               </div>
                <div className="copyright">
                    <p className="extra-title--h7">© 2011-2021 Powtoon.com, Inc</p>
               </div>
            </footer>
        );
    }
}
